var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("search-input", {
        attrs: {
          "search-block-style": "search-block-styles",
          "input-classes": "site-search-input",
          iconsize: "30",
          iconcolor: "#c0c4d5",
          "on-input": _vm.setSearchTerm,
          "form-action": _vm.$helpers.getSearchTermUrl(_vm.searchTerm),
          "placeholder-value": "search",
          value: _vm.searchTerm
        }
      }),
      _vm._v(" "),
      _vm.searchTerm
        ? _c(
            "div",
            { staticClass: "wf-search-menu-dropdown-wrapper d-block" },
            [
              _c(
                "div",
                { staticClass: "wf-search-menu-results-for-message w-100" },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$resourceString["site.search.search.result.for"]
                      ) +
                      ' "' +
                      _vm._s(_vm.searchTerm) +
                      '":\n    '
                  )
                ]
              ),
              _vm._v(" "),
              _vm.showNoResults
                ? _c(
                    "div",
                    {
                      staticClass:
                        "wf-search-menu-no-results-message pl-4 pt-2 text-capitalize text-dark font-weight-bold"
                    },
                    [
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.$resourceString["common.noResults"]) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.showNoResults
                ? _c("div", { staticClass: "wf-search-menu-dropdown" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "wf-search-menu-options wf-search-menu-sidemenu-displayed"
                      },
                      [
                        _c(
                          "ul",
                          {
                            staticClass:
                              "wf-search-menu-options-list text-uppercase"
                          },
                          _vm._l(
                            ["all", "collections", "styles", "pages"],
                            function(scopeOption) {
                              return _c(
                                "li",
                                {
                                  key: scopeOption,
                                  staticClass: "wf-search-menu-options-item"
                                },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "\n                wf-search-menu-options-link\n                wf-search-menu-options-link-desktop\n                btn btn-full\n                scope-button\n              ",
                                      class: [
                                        scopeOption === _vm.scope
                                          ? "wf-search-menu-options-link-active"
                                          : ""
                                      ],
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.setScope(scopeOption)
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scopeOption) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ]
                              )
                            }
                          ),
                          0
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mobile-site-search-result" },
                      [_c("mobile-search-results")],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "wf-search-menu-results mb-4" },
                      [
                        !_vm.isFetching ? _c("search-results") : _vm._e(),
                        _vm._v(" "),
                        _vm.isFetching
                          ? _c("div", { staticClass: "d-flex w-100 h-100" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "spinner-border primary-black m-auto",
                                  attrs: { role: "status" }
                                },
                                [
                                  _c("span", { staticClass: "sr-only" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$resourceString[
                                          "site.search.container.loading"
                                        ]
                                      )
                                    )
                                  ])
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                : _vm._e()
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }